import { Loader } from '@calendly/ui/components/loader';
import classNames from 'classnames';
import { forwardRef } from 'react';
const dayLoaderCss = "d1xy3eby";
export const DayLoader = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} data-container="days-loader" className={classNames(dayLoaderCss, props.className)}>
      <Loader data-testid="loader" />
    </Component>;
});

require("./day_loader.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./day_loader.js");